// Scripts librairies
/* global Waypoint */
import 'waypoints/lib/jquery.waypoints.min.js'
import './js/libs/paginate/jquery.paginate.min.js'
import { scroll } from './js/libs/utils.js'

require('./common.js')

// rafraîchissement
function r () {
  Waypoint.refreshAll()
}

// focus sur un type de demande
function progressBar (c) {
  $('#' + c)
    .stop(true, true)
    .animate({ opacity: 1 }, 200)
    .show()
    .removeClass('d-none')
  $('#' + c)
    .find('.progress-bar')
    .addClass('')
  $('.layer-load').removeClass('active')
  $('.' + c).addClass('active')
  scroll('#' + c)
}

function getMaPrimeRenovSimulator () {
  import('./js/components/form-simulator-helps.js').then(() => {
    r()
    progressBar('simulator-section')
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  getMaPrimeRenovSimulator()

  /*
  const $f = $('#simulator-section')
  if ($f.length) {
    $f.waypoint(
      function () {
        getMaPrimeRenovSimulator()
        this.destroy()
      },
      {
        offset: '100%'
      }
    )
  }
  */
})
